import {
    CheckCircle, FileCheck, Banknote, Users, Mail, Layout, UserCog, FileText,
    BarChart2, Settings, CheckSquare, MonitorPlay, Layers, Briefcase, Plus,
    BookOpen, Truck, Building, Package, Scissors, Warehouse, Cpu, HardHat,
    Hand, Shirt, Feather, PackageCheck, WashingMachine, Wrench, BrainCircuit,
    TestTube, LayoutDashboard, Settings2, GaugeCircle, Sun, Activity, Power,
    Car, Bike, Bus, Rocket, BarChartBig, UsersRound, Download, Flame, Fan,
    ToggleRight, ArrowDownToLine, ArrowUpFromLine, X, Image as ImageIcon,
    Search, FlaskConical, ArrowUpRight, MapPin, Eye, PenTool, ClipboardCheck, AlertTriangle, Thermometer,
    ArrowDownLeft, Shield, BarChart3, Globe, Calculator
} from 'lucide-react';

const iconMap = {
    CheckCircle,
    FileCheck,
    Banknote,
    Users,
    Mail,
    Layout,
    UserCog,
    FileText,
    BarChart2,
    Settings,
    CheckSquare,
    MonitorPlay,
    Layers,
    Briefcase,
    Plus,
    BookOpen,
    Truck,
    Building,
    Package,
    Scissors,
    Warehouse,
    Cpu,
    HardHat,
    Hand,
    Shirt,
    Feather,
    PackageCheck,
    WashingMachine,
    Wrench,
    BrainCircuit,
    TestTube,
    LayoutDashboard,
    Settings2,
    GaugeCircle,
    Sun,
    Activity,
    Power,
    Car,
    Bike,
    Bus,
    Rocket,
    BarChartBig,
    UsersRound,
    Download,
    Flame,
    Fan,
    ToggleRight,
    ArrowDownToLine,
    ArrowUpFromLine,
    X,
    Search,
    FlaskConical,
    ArrowUpRight,
    MapPin,
    Eye,
    PenTool,
    ClipboardCheck,
    AlertTriangle,
    Thermometer,
    ArrowDownLeft,
    Shield,
    BarChart3,
    Globe,
    Calculator
};

export const IconRenderer = ({ iconName, ...props }) => {
    const IconComponent = iconMap[iconName];
    if (!IconComponent) return <ImageIcon {...props} />;
    return <IconComponent {...props} />;
};

